<!-- <div class="row">
  <div class="col-10">
    <nav class="navbar navbar-expand-lg ">
      <img class="bcbsri-image" src="../../assets/images/bcbsri-new.PNG" alt="logo2">
    </nav>
  </div>
  
    
      <span class = "helplogout">
  <div class="col-2">
    <a class="getHelp">NeedHelp</a>

</div>
</span>
 <span class = "helplogout">
  <div class="col-2">
    <a class="logout" routerLink="/logout" routerLinkActive="active">Logout</a>

  </div>
</span>


</div> -->
<app-header></app-header>

<div class="container-fluid bg-light px-lg-5">
  <nav class="navbar navbar-expand-lg navbar-light">
    <!-- <a class="navbar-brand" href="#"></a> -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/registration">App Registration <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/app-mgmt">App Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/profile-mgmt">Profile Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/resources">Resources</a>
        </li>

      </ul>
    </div>
  </nav>
</div>
<br>
<div *ngIf="recreatesecret" class="row justify-content-center">
  <div class="col-md-8">
    <div class="card">
      <div class="card-header"><b>You have Successfully regenerated the Secret. </b></div>
      <div class="card-body">
        <div>
          <p><b>Application Name :</b> {{displayNme}}</p>
          <p><b>ClientId :</b> {{ clntId }}</p>
          <p><b>ClientSecret:</b>{{createsecretClientID}}</p>
          <p><b>Please note down the ClientSecret for your future reference. It will be not shown again.</b></p>
        </div>
      </div>
    </div>
  </div>
</div>





<div class="container-fluid">
  <div *ngIf="content" class="row">
    <div class=" welcome-main col-lg-12">
      <div class="welcome">
        <h1 class="title">Developer Portal</h1>
        <h5 class="sub_title">
          <p style="font-size: 20px;"></p>
          <span>
            Welcome to the all-new BCBSRI Third Party Developer portal !!!
          </span>
          <p style="font-size: 20px;">
          </p>
          <span>
            You'll experience a faster, easier way to register the application and manage.
          </span>
          <p style="font-size: 20px;">
          </p>
          <span>
            Click on Add App,Register new app.Authenticated & active user would be able to create new Application
            registration via the Developer Portal.
          </span>
          <p style="font-size: 20px;">
          </p>
          <span>
            Authenticated & active user would be able to manage all the applications for the organization. They would be
            able to request for new Client Secret. Or Edit the application details, and same application validations
            would be applied.
          </span>
        </h5>

      </div>

    </div>
    <!-- <div class=" welcome-photo col-lg-6">

      <img class="welcome-image" src="../../assets/images/welcomefinal.PNG" alt="logo2">


    </div>  -->
  </div>

  <div *ngIf="addApplogo" class="addApp">
    <a class="nav-link" routerLink="/registration"><i class="fa fa-plus"></i> Add App</a>
  </div>

  <p *ngIf="isLoading" class="loading"><i class="fa fa-spinner"></i>...Loading</p>
  <div *ngIf="isDeleting" class="recreateWait">
    <p class="deleting-spinner">Deleting After Your Confirmation...</p>
  </div>
  <p *ngIf="recreateWait" class="recreateWait">Please wait..</p>





  <div *ngIf="appslist" class="container">

    <!-- <div class="row justify-content-md-center"> -->
    <div class="row list-header">
      <div class="col-2 left-margin" style="background-color: rgba(0,0,0,.03); ">
        <h5>App Name</h5>
      </div>
      <div class="col-3 left-margin" style="background-color:rgba(0,0,0,.03);">
        <h5>Redirect URl</h5>
      </div>
      <div class="col-4 left-margin" style="background-color: rgba(0,0,0,.03);">
        <h5>ClientId</h5>
      </div>
      <div class="col-3 left-margin" style="background-color: rgba(0,0,0,.03);">
        <h5>Action</h5>
      </div>
    </div>


    <div class="w-100 d-none d-md-block"></div>

    <div class="row" *ngFor="let apps of loadedApps; let i = index"
      [ngStyle]="{backgroundColor:i%2==0? 'white':'#f1f1f1'}">
      <div class="col-2 left-margin">
        {{ apps.displayName }}
      </div>
      <div class="col-3 left-margin">
        {{ apps.web.uri}}
      </div>
      <div class="col-4 left-margin">
        {{ apps.clientId }}
      </div>
      <div class="col-3 left-margin">
        <!-- <a class="nav-link" routerLink = "/app-mgmt" >App Management</a> -->

        <!-- <a [routerLink]="['edit-app', apps.id]"></a> -->
        <a [routerLink]="['/edit-app', apps.id]" class="">Edit<span> | </span></a>
        <!-- <a routerLink = "/edit-app"  class = "" >Edit</a>  -->
        <!-- <a href = "" class = "" (click) ="onEditAppItem(apps.id)">Edit</a> -->
        <!-- <button type="button" class=" btn btn-primary" 
          mwlConfirmationPopover
        [popoverTitle]="popoverTitle"
        [popoverMessage]="popoverMessage"
        placement="left"
        (confirm)="onDeleteApp(apps.id)"
        (cancel)="cancelClicked = true">
            <i class="fa fa-user-circle"></i> Delete
          </button> -->
        <a class="delete" (click)="getAppId(apps.displayName)" mwlConfirmationPopover [popoverTitle]="popoverTitle"
          [popoverMessage]="popoverMessage" placement="left" (confirm)="onDeleteApp(apps.id)"
          (cancel)="cancelClicked = true"> Delete<span> | </span></a>
        <!-- <a class = "" href = ""> Delete</a> -->
        <a class="create" (click)="onCreateRecreateSecret(apps.id,apps.clientId,apps.displayName )"> Recreate-Secret</a>

      </div>
      <!-- <a class = "" href = ""> Delete</a>
        <a class = "" href = ""> Recreate Sceret</a>   -->
      <!-- <div class = "col-1">
        <button type="button" class=" btn btn-primary">
          <i class="fa fa-user-circle"></i> Delete
        </button>
        </div> -->

    </div>

    <!-- <div>
  
        <a class = "" href = ""> Recreate Sceret</a>  
      </div> -->
    <!-- </div> -->
  </div>
  <div>
    <app-footer></app-footer>
  </div>